var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 4.4375C36.0884 4.4375 36.6528 4.67126 37.0689 5.08736C37.485 5.50345 37.7187 6.0678 37.7187 6.65625V58.9877L51.6791 45.0229C52.0957 44.6063 52.6608 44.3722 53.25 44.3722C53.8392 44.3722 54.4042 44.6063 54.8209 45.0229C55.2375 45.4395 55.4715 46.0046 55.4715 46.5938C55.4715 47.1829 55.2375 47.748 54.8209 48.1646L37.0709 65.9146C36.8648 66.1213 36.6199 66.2852 36.3504 66.397C36.0808 66.5089 35.7918 66.5665 35.5 66.5665C35.2081 66.5665 34.9192 66.5089 34.6496 66.397C34.3801 66.2852 34.1352 66.1213 33.9291 65.9146L16.1791 48.1646C15.7625 47.748 15.5284 47.1829 15.5284 46.5938C15.5284 46.0046 15.7625 45.4395 16.1791 45.0229C16.5957 44.6063 17.1608 44.3722 17.75 44.3722C18.3392 44.3722 18.9042 44.6063 19.3209 45.0229L33.2812 58.9877V6.65625C33.2812 6.0678 33.515 5.50345 33.9311 5.08736C34.3472 4.67126 34.9115 4.4375 35.5 4.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiArrowDown);
export default __webpack_public_path__ + "static/media/bi_arrow-down.6ae32cd872ea6e8652309147b3e13631.svg";
export { ForwardRef as ReactComponent };